import { PricingTier, AgentPricing } from '../interfaces/platform-pricing';

/** Agent prricing data */
export class AgentPricingModel {
  public included_units: number;
  public minimum_units: number;
  public additional_price: number;
  public tiered_pricing: boolean;
  public unit_price: number;
  public tiers: PricingTier[];
  private agentCount: number;

  constructor(agentPricing: AgentPricing, agentCount?: number) {
    Object.assign(this, agentPricing);
    this.agentCount = agentCount || agentPricing.included_units;
  }

  /** Returns the current tier based on the agent count */
  public get currentTier(): PricingTier {
    return this.tiers?.find((tier) => {
      return (
        this.agentCount >= tier.starting_unit &&
        (tier.ending_unit === null || this.agentCount <= tier.ending_unit)
      );
    });
  }

  /** Returns the current tier price, or the static unit price, or zero */
  public get perAgentPrice(): number {
    return this.currentTier?.price || this.unit_price || 0;
  }

  /**
   * Returns perAgentPrice times number of agents,
   * or times the minimum agent count if agentCount is less than the minimum
   */
  public get totalCost(): number {
    const agentMultiplier =
      this.minimum_units && this.agentCount < this.minimum_units
        ? this.minimum_units
        : this.agentCount;
    return this.tierHasFlatFee
      ? this.perAgentPrice
      : this.perAgentPrice * agentMultiplier;
  }

  /**
   * Returns boolean based on whether current tier has a flat fee
   * in this case, we would want to use the per agent price for total cost
   */
  public get tierHasFlatFee(): boolean {
    return this.currentTier?.price_format === 'FlatFee';
  }
}
